// extracted by mini-css-extract-plugin
export default {"wrap":"SearchModeTabs_wrap__8NeMi","tab":"SearchModeTabs_tab__MOKOa","active":"SearchModeTabs_active__-bOrc"};